module.exports = __webpack_public_path__ + "img/home-banner-03.7b116853.jpg";